/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState } from 'react';
import {
  Avatar,
  Button,
  Box,
  Text,
  useMediaQuery,
  Icon as ChakraIcon,
  Flex,
  IconButton,
} from '@chakra-ui/react';
import { FaCheck, FaImage, FaMicrophone, FaVideo } from 'react-icons/fa';
import { Icon } from 'rsuite';
import { Pagination, Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import { BsChatDotsFill, BsChatFill } from 'react-icons/bs';
import { Prompt, QuestionResponse, User } from '../../../@types';
import '@uppy/core/dist/style.css';
import '@uppy/webcam/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import '@uppy/drag-drop/dist/style.css';
import '@uppy/audio/dist/style.css';
import {
  TextResponse,
  VideoResponseModal,
  AudioResponseModal,
  ImageResponseModal,
} from '../../response-inputs';

import * as Constants from '../../../constants';
import { useEpisodeStore } from '../../../store';
import {
  usePromptResponses,
  useUserPromptResponses,
  useCurrentUser,
} from '../../../api';
import { QuestionResponseView } from './QuestionResponseView';

const ResponseTypeButton: React.FC<{
  user?: User;
  type: number;
  prompt: Prompt;
  hasExisting: boolean;
}> = ({ user, type, prompt, hasExisting = false }) => {
  // const [state, dispatch] = usePrompt();
  // const [showSuccess, setShowSuccess] = useState(false);
  const [showTextResponseModal, setShowTextResponseModal] = useState(false);
  const [showVideoResponseModal, setShowVideoResponseModal] = useState(false);
  const [showAudioResponseModal, setShowAudioResponseModal] = useState(false);
  const [showImageResponseModal, setShowImageResponseModal] = useState(false);

  const handleStartResponse = (responseType: number) => {
    switch (responseType) {
      case Constants.RESPONSE_TYPE_IDS.TEXT:
        setShowTextResponseModal(true);
        break;
      case Constants.RESPONSE_TYPE_IDS.VIDEO:
        setShowVideoResponseModal(true);
        break;
      case Constants.RESPONSE_TYPE_IDS.AUDIO:
        setShowAudioResponseModal(true);
        break;
      case Constants.RESPONSE_TYPE_IDS.IMAGE:
        setShowImageResponseModal(true);
        break;
      default:
        return null;
    }
    return false;
  };
  if (type === Constants.RESPONSE_TYPE_IDS.DRAW) return null;
  const styleByType: any = {
    [Constants.RESPONSE_TYPE_IDS.TEXT]: {
      right: -6,
      bottom: 6,
      colorScheme: 'blue',
      icon: <BsChatDotsFill />,
    },
    [Constants.RESPONSE_TYPE_IDS.VIDEO]: {
      right: 14,
      top: -4,
      colorScheme: 'red',
      icon: <FaVideo />,
    },
    [Constants.RESPONSE_TYPE_IDS.AUDIO]: {
      left: 14,
      top: -4,
      colorScheme: 'darkBlue',
      icon: <FaMicrophone />,
    },
    [Constants.RESPONSE_TYPE_IDS.IMAGE]: {
      left: -6,
      bottom: 6,
      colorScheme: 'newGreen',
      icon: <FaImage />,
    },
  };

  console.log();

  return (
    <>
      <Button
        aria-label="like"
        icon={<FaImage />}
        borderRadius="full"
        position="absolute"
        h={16}
        w={16}
        fontSize={24}
        shadow="0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 5px 0px -1px rgba(0, 0, 0, 0.1)"
        onClick={(e) => handleStartResponse(type)}
        {...styleByType?.[String(type)]}
      >
        {!!hasExisting && (
          <ChakraIcon
            {...{
              position: 'absolute',
              className: 'completed-check',
              transitionDuration: '1s',
              top: '-4px',
              right: '-14px',
              bg: 'newGreen.500',
              color: 'white',
              rounded: 'full',
              boxSize: 7,
              zIndex: 'popover',
              pointerEvents: 'none',
              border: '2px solid',
              borderColor: 'white',
              boxShadow: 'xl',
              p: 1,
            }}
            as={FaCheck}
          />
        )}
        {styleByType?.[String(type)]?.icon}
      </Button>

      {type === Constants.RESPONSE_TYPE_IDS.TEXT && (
        <TextResponse
          promptId={prompt.id}
          questionText={prompt.text}
          show={showTextResponseModal}
          setShowTextResponseModal={setShowTextResponseModal}
        />
      )}
      {type === Constants.RESPONSE_TYPE_IDS.VIDEO &&
        user &&
        showVideoResponseModal && (
          <VideoResponseModal
            icon={Constants.RESPONSE_TYPE_ICONS[type]}
            user={user}
            promptId={prompt.id}
            questionText={prompt.text}
            show
            setShowVideoResponseModal={setShowVideoResponseModal}
            closeModal={() => setShowVideoResponseModal(false)}
          />
        )}
      {type === Constants.RESPONSE_TYPE_IDS.AUDIO &&
        user &&
        showAudioResponseModal && (
          <AudioResponseModal
            icon={Constants.RESPONSE_TYPE_ICONS[type]}
            user={user}
            promptId={prompt.id}
            questionText={prompt.text}
            show
            setShowAudioResponseModal={setShowAudioResponseModal}
            closeModal={() => setShowAudioResponseModal(false)}
          />
        )}
      {type === Constants.RESPONSE_TYPE_IDS.IMAGE &&
        user &&
        showImageResponseModal && (
          <ImageResponseModal
            icon={Constants.RESPONSE_TYPE_ICONS[type]}
            user={user}
            promptId={prompt.id}
            questionText={prompt.text}
            show
            setShowImageResponseModal={setShowImageResponseModal}
            closeModal={() => setShowImageResponseModal(false)}
          />
        )}
    </>
  );
};

const ExistingResponses: React.FC<{
  responses: [QuestionResponse[]];
  handleOpenResponse: (responseId: string) => void;
}> = ({ responses = [], handleOpenResponse }) => {
  const { data: user } = useCurrentUser();
  const [isSmall] = useMediaQuery('(max-width: 700px)');

  return (
    <div className="responses-wrapper">
      <Box w="full" h="150px">
        <Swiper
          observer
          direction="horizontal"
          scrollbar={false}
          centeredSlides={false}
          preventClicksPropagation={false}
          navigation
          speed={400}
          style={{ height: '100%' }}
          pagination={{
            clickable: true,
            type: 'bullets',
          }}
          modules={[Pagination, Navigation]}
          breakpoints={{
            10: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 10,
            },
            500: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 10,
            },
            700: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              spaceBetween: 10,
            },
            900: {
              slidesPerView: 4,
              slidesPerGroup: 4,
              spaceBetween: 10,
            },
          }}
        >
          {!!responses.length &&
            responses.map((userResponses, i) => {
              const response = userResponses[0];
              const { id, username, icon } = response.user;
              return (
                <SwiperSlide key={i}>
                  <Flex
                    bg="ligthBlue.500"
                    _hover={{ bg: 'ligthBlue.600' }}
                    cursor="pointer"
                    p={4}
                    borderRadius={24}
                    gap={4}
                    pr={8}
                    w="full"
                    aria-label={`View ${username}'s Response`}
                    onClick={(e) => handleOpenResponse(response.user.id)}
                    alignItems="center"
                    color="darkBlue.500"
                  >
                    <Avatar
                      size={isSmall ? 'md' : 'lg'}
                      name={username}
                      src={
                        icon
                          ? `${Constants.ROOT_URL}/img/${icon.file_name}`
                          : ''
                      }
                    />
                    <div className="response-info">
                      <Box position="relative">
                        <Text
                          fontSize={14}
                          fontWeight={800}
                          isTruncated
                          maxW="90%"
                        >
                          {username}
                        </Text>

                        {user && user.id === id && (
                          <Text
                            position="absolute"
                            bg="red.400"
                            color="white"
                            fontSize={10}
                            top={-4}
                            right={-6}
                            fontWeight={700}
                            w={7}
                            h={7}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            borderRadius="full"
                            mt={0}
                          >
                            You
                          </Text>
                        )}
                      </Box>

                      <Flex alignItems="center" gap={1}>
                        <ChakraIcon as={BsChatFill} />
                        <Text fontSize={12} fontWeight={600} mt={1}>
                          {response.response_comments
                            ? response.response_comments.length
                            : 0}{' '}
                        </Text>
                      </Flex>
                    </div>
                  </Flex>
                </SwiperSlide>
              );
            })}
          <div className="swiper-pagination" />
        </Swiper>
      </Box>
    </div>
  );
};

export const QuestionPromptWrapper: React.FC<{
  prompt: Prompt;
}> = ({ prompt }) => {
  const { data: user } = useCurrentUser();
  const { getPromptStateById, PROMPT_ACTIONS } = useEpisodeStore((state) => ({
    PROMPT_ACTIONS: state.PROMPT_ACTIONS,
    getPromptStateById: state.getPromptStateById,
  }));

  const state = getPromptStateById(prompt.id);
  const { data: responses = [] } = usePromptResponses(prompt.id);
  const { data: myResponses = [] } = useUserPromptResponses(
    prompt.id,
    user?.id || ''
  );
  const handleOpenResponse = (userId: string) => {
    PROMPT_ACTIONS.openResponse(prompt.id, userId);
  };

  return (
    <>
      {!state.responsesOpen && (
        <>
          {!!responses.length && (
            <>
              <div className="label-text">What Others Are Saying...</div>
              <ExistingResponses
                handleOpenResponse={handleOpenResponse}
                responses={responses}
              />
            </>
          )}

          <div className="response-select-wrapper">
            <Flex
              w={280}
              h={130}
              bg="ligthBlue.500"
              borderRadius="180px 180px 0 0"
              borderBottom="transparent"
              justifyContent="center"
              alignItems="center"
              position="relative"
              alignSelf="center"
              mb={-2}
            >
              <ResponseTypeButton
                prompt={prompt}
                user={user}
                type={Constants.RESPONSE_TYPE_IDS.AUDIO}
                hasExisting={!!myResponses[Constants.RESPONSE_TYPE_IDS.AUDIO]}
              />
              <ResponseTypeButton
                prompt={prompt}
                user={user}
                type={Constants.RESPONSE_TYPE_IDS.IMAGE}
                hasExisting={!!myResponses[Constants.RESPONSE_TYPE_IDS.IMAGE]}
              />
              <ResponseTypeButton
                prompt={prompt}
                user={user}
                type={Constants.RESPONSE_TYPE_IDS.VIDEO}
                hasExisting={!!myResponses[Constants.RESPONSE_TYPE_IDS.VIDEO]}
              />
              <ResponseTypeButton
                prompt={prompt}
                type={Constants.RESPONSE_TYPE_IDS.DRAW}
                hasExisting={!!myResponses[Constants.RESPONSE_TYPE_IDS.DRAW]}
              />
              <ResponseTypeButton
                prompt={prompt}
                type={Constants.RESPONSE_TYPE_IDS.TEXT}
                hasExisting={!!myResponses[Constants.RESPONSE_TYPE_IDS.TEXT]}
              />
              <Text
                fontSize={12}
                fontWeight={700}
                w="min-content"
                textAlign="center"
                mt={10}
              >
                {responses
                  ? 'Join the Conversation...'
                  : 'Start the Conversation...'}
              </Text>
            </Flex>
          </div>
        </>
      )}

      {!!responses.length && state.responsesOpen && (
        <QuestionResponseView responses={responses} promptId={prompt.id} />
      )}
    </>
  );
};
